import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { CleanCopterPage } from './pages/CleanCopterPage';
import { CareersPage } from './pages/CareersPage';
import { ContactPage } from './pages/ContactPage';
import { ImpressumPage } from './pages/ImpressumPage';
export function App() {
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen bg-white font-sans text-gray-900" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/ueber-uns" element={<AboutPage data-id="element-8" />} data-id="element-7" />
            <Route path="/leistungen" element={<ServicesPage data-id="element-10" />} data-id="element-9" />
            <Route path="/cleancopter" element={<CleanCopterPage data-id="element-12" />} data-id="element-11" />
            <Route path="/karriere" element={<CareersPage data-id="element-14" />} data-id="element-13" />
            <Route path="/kontakt" element={<ContactPage data-id="element-16" />} data-id="element-15" />
            <Route path="/impressum" element={<ImpressumPage data-id="element-18" />} data-id="element-17" />
          </Routes>
        </main>
        <Footer data-id="element-19" />
      </div>
    </Router>;
}